<template>
  <div class="w-100 h-100">
    <statistic-card-horizontal
      :is-loading="isLoading"
      icon="DribbbleIcon"
      :statistic="chartData"
      :statistic-title="title"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      title: 'Average Bounce Rate',
      chartData: 0,
      colors: [
        this.$themeColors.primary,
        this.$themeColors.dark,
      ],
    }
  },
  created() {
    this.initComponent()
  },
  methods: {
    initComponent() {
      const reportId = this.$route.params.report_name.split('__')[1]

      this.isLoading = true
      this.$http
        .post(`/api/event-reports/analytics`, {
          form_data: {
            fetch_data: ['avg_bounce_rate'],
            report_id: reportId,
          },
        })
        .then(response => {
          const { reports } = response.data
          this.chartData = reports['avg_bounce_rate']

          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
        })
    }
  },
}
</script>

<style>

</style>